import type { UserPreferencesNotificationsHeaderProps } from "./user-preferences-notifications-header.type";

import { ReloadOutlined } from "@ant-design/icons";
import { Button, Flex, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";

import { UserPreferencesNotificationsDropdown } from "../user-preferences-notifications-dropdown";

import { useUserPreferencesNotificationsHeader } from "./user-preferences-notifications-header.hook";

import "./user-preferences-notifications-header.style.less";

const { Title } = Typography;

export const UserPreferencesNotificationsHeader = (
  props: UserPreferencesNotificationsHeaderProps
) => {
  const { t } = useTranslation();
  const { menuItems, onReloadClick, onMenuItemClick } =
    useUserPreferencesNotificationsHeader(props);

  return (
    <Flex gap="large" className="user-preferences-notifications-header">
      <Title level={2}>{t("user:preferences.notifications.title")}</Title>
      <Flex>
        <Space.Compact>
          <Button icon={<ReloadOutlined />} onClick={onReloadClick}>
            {t("user:preferences.notifications.actions.resetAll")}
          </Button>
          <UserPreferencesNotificationsDropdown
            menuItems={menuItems}
            onMenuItemClick={onMenuItemClick}
          />
        </Space.Compact>
      </Flex>
    </Flex>
  );
};
